import { createFileRoute } from '@tanstack/react-router';
import { resolveOrganizationRef } from '@/app/organization-ref';
import { OrganizationDetailPage } from '@/features/operator/detail/organization-detail-page';

export const Route = createFileRoute('/operator/organizations/$organizationId')({
    beforeLoad: ({ context, params, location }) =>
        resolveOrganizationRef(context.queryClient, params.organizationId, location),
    staticData: {
        crumbs: [
            { label: 'shell.operatorConsole', to: '/operator' },
            { label: 'operator.nav.organizations', to: '/operator/organizations' },
            { label: 'shell.crumbOrganization' },
        ],
    },
    component: function OperatorOrganizationRoute() {
        const { organizationId } = Route.useParams();
        return <OrganizationDetailPage key={organizationId} organizationId={organizationId} />;
    },
});
